import { Component, Input, OnDestroy, OnInit } from '@angular/core';

const { version: appVersion } = require('../../../package.json');

@Component({
  selector: 'rm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit{

    appVersion: any;

    ngOnInit() {
        this.appVersion = appVersion;
    }
}